import {
  ImageCarouselBlock,
  ImageCarouselMessage,
  TableChatMessage,
  TableContentBlock,
} from '@/services/mockAPI/mockData.types';
import { imageData, tableData } from './mockData';

export const mockTablePrompt = async (): Promise<TableChatMessage> => {
  // Simulate a small delay to mimic API call
  await new Promise(resolve => setTimeout(resolve, 300));

  const blocks: TableContentBlock[] = [{ type: 'table', data: tableData }];

  return {
    role: 'assistant',
    content: 'Here is the asset inventory data you requested:',
    timestamp: new Date().toISOString(),
    blocks,
    extras: {
      tableData,
    },
    messageCompleted: true,
  };
};

export const mockImageCarouselPrompt =
  async (): Promise<ImageCarouselMessage> => {
    await new Promise(resolve => setTimeout(resolve, 300));

    const blocks: ImageCarouselBlock[] = [
      {
        type: 'image_carousel',
        data: { images: imageData },
      },
    ];

    return {
      role: 'assistant',
      content: 'Here is the image carousel you requested:',
      timestamp: new Date().toISOString(),
      blocks,
      messageCompleted: true,
    };
  };
